<template>
  <div class="container-fluid" v-html="coupon.content"></div>
</template>

<script>
export default {
  props: {
    coupon: Object,
  },

  mounted() {
    this.$nextTick(() => {
      window.customScripts();
    });
  },
};
</script>

<style lang="scss"></style>
